import React from "react";
import { formatDMS, fmt } from "../lib/api";

/**
 * Big tactical readout panel: Hz, V, SD, X, Y, Z
 */
export const LiveReadout = ({ state }) => {
  const hz = state?.hz ?? 0;
  const v = state?.v ?? 0;
  const sd = state?.sd ?? null;
  const x = state?.target_x ?? null;
  const y = state?.target_y ?? null;
  const z = state?.target_z ?? null;

  return (
    <div className="panel scanlines relative overflow-hidden" data-testid="live-readout-panel">
      <div className="panel-header">
        <span>LIVE READOUT</span>
        <span className={`text-[10px] ${state?.turning ? "text-[var(--amber)] glow-amber" : "text-[var(--text-mute)]"}`}>
          {state?.turning ? "SERVO ACTIVE" : "IDLE"}
        </span>
      </div>
      <div className="grid grid-cols-2 gap-px bg-[var(--border)]">
        <Cell label="Hz" testid="live-hz-readout" glow="glow-green" color="text-[var(--neon)]">
          {formatDMS(hz)}
        </Cell>
        <Cell label="V" testid="live-v-readout" glow="glow-green" color="text-[var(--neon)]">
          {formatDMS(v)}
        </Cell>
        <Cell label="SD (m)" testid="live-sd-readout" glow="glow-amber" color="text-[var(--amber)]">
          {fmt(sd, 3)}
        </Cell>
        <Cell label="Δ mrad" testid="live-delta-readout" glow="glow-cyan" color="text-[var(--cyan)]">
          {fmt((state?.tilt_x ?? 0) * 1000, 2)} / {fmt((state?.tilt_y ?? 0) * 1000, 2)}
        </Cell>
      </div>
      <div className="grid grid-cols-3 gap-px bg-[var(--border)]">
        <Small label="X" testid="live-x-readout">{fmt(x, 3)}</Small>
        <Small label="Y" testid="live-y-readout">{fmt(y, 3)}</Small>
        <Small label="Z" testid="live-z-readout">{fmt(z, 3)}</Small>
      </div>
    </div>
  );
};

const Cell = ({ label, testid, children, color, glow }) => (
  <div className="bg-[var(--surface)] px-5 py-4">
    <div className="text-[10px] tracking-[0.3em] text-[var(--text-dim)]">{label}</div>
    <div
      data-testid={testid}
      className={`readout mt-1 text-4xl font-bold tabular-nums lg:text-5xl ${color} ${glow}`}
    >
      {children}
    </div>
  </div>
);

const Small = ({ label, testid, children }) => (
  <div className="bg-[var(--surface)] px-4 py-3">
    <div className="text-[10px] tracking-[0.3em] text-[var(--text-dim)]">{label}</div>
    <div data-testid={testid} className="readout mt-0.5 text-xl font-semibold tabular-nums text-[var(--text)]">
      {children}
    </div>
  </div>
);
